import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/auth/auth.service';
import { handleApiError } from 'src/app/helper/helper';
import { OverviewData } from 'src/app/interfaces/overview.interface';
import { ApiService } from 'src/app/services/api.service';

export interface TableRows {
  entity: string;
  count: number;
}

@Component({
  standalone: false,
  selector: 'app-overview',
  templateUrl: './overview.component.html',
})
export class OverviewComponent implements OnInit {
  overviewData: OverviewData | undefined;

  constructor(
    private apiService: ApiService,
    private authService: AuthService,
    private router: Router
  ) {}

  ngOnInit(): void {
    this.loadOverviewData();
  }

  getTableRows(): TableRows[] {
    let tableRows: TableRows[] = [];
    if (this.overviewData) {
      tableRows = [
        {
          entity: 'Fields',
          count: this.overviewData.fieldsCount,
        },
        {
          entity: 'FieldHistories',
          count: this.overviewData.fieldHistoriesCount,
        },
        {
          entity: 'Signatures',
          count: this.overviewData.signaturesCount,
        },
        {
          entity: 'SignatureHistories',
          count: this.overviewData.signatureHistoriesCount,
        },
        {
          entity: 'SubspaceScans',
          count: this.overviewData.scans,
        },
        {
          entity: 'SubspaceScanHistories',
          count: this.overviewData.scanHistories,
        },
        {
          entity: 'SubspaceScanObjects',
          count: this.overviewData.scanObjects,
        },
        {
          entity: 'SubspaceScanObjectHistories',
          count: this.overviewData.scanObjectHistories,
        },
        {
          entity: 'Players',
          count: this.overviewData.playersCount,
        },
        {
          entity: 'PlayerHistories',
          count: this.overviewData.playersHistoryCount,
        },
        {
          entity: 'Alliances',
          count: this.overviewData.alliancesCount,
        },
        {
          entity: 'AllianceHistories',
          count: this.overviewData.allianceHistoryCount,
        },
      ];
    }
    return tableRows;
  }

  async loadOverviewData() {
    try {
      this.overviewData = await this.apiService.fetchOverview();
    } catch (error) {
      handleApiError(this.authService, this.router, error);
    }
  }
}
